import * as React from 'react';
import { SharedLegalPage } from './_shared/SharedLegalPage';

export const SecurityReportingPage: React.FC = () => {
  return (
    <SharedLegalPage label="Security Reporting">
      <>
        <h2>Our Commitment</h2>

        <p>
          Security of our users’ data is of utmost importance at JourneyApps. We welcome the disclosure of any
          vulnerability you may find in our platform.
        </p>
        <p>
          We will treat each security report with the utmost seriousness. We commit to communicating promptly while we
          investigate the impact on our customers and will remediate the issue if deemed necessary.
        </p>
        <p>We uphold the principles of Responsible Disclosure, including but not limited to:</p>
        <ul>
          <li>Make every effort to avoid accessing data of other users, and avoid disruption of our services.</li>
          <li>Keep within our Terms of Service.</li>
          <li>
            Avoid publicly disclosing any vulnerability until JourneyApps has had reasonable time to resolve or mitigate
            the issue.
          </li>
        </ul>
        <p>
          Additionally, avoid any social engineering or phishing on our customers or employees, and do not physically
          access any of our properties.
        </p>

        <p>If you follow the responsible disclosure guidelines, we commit to:</p>
        <ul>
          <li>Treat each report with the utmost seriousness.</li>
          <li>Communicate promptly, and work with you to understand and resolve the issue.</li>
        </ul>

        <p>
          JourneyApps does not operate a bug bounty program at this time, but may choose to offer a reward for security
          reports at our discretion.
        </p>

        <h2>How to report an issue</h2>
        <p>
          Contact <a href="mailto:security@journeyapps.com">security@journeyapps.com</a> with details on the issue.
        </p>
        <p>Include at least the following information:</p>
        <ol>
          <li>A description and severity of the issue.</li>
          <li>Steps to reproduce the issue.</li>
          <li>Any sensitive details that you may have accidentally accessed during the research.</li>
        </ol>
        <p>
          If you plan to provide sensitive credentials or data in the report, please let us know, and we will provide
          you with a public GPG key for encryption.
        </p>

        <h2>What reports we are interested in</h2>
        <p>We are interested in any reports affecting the security of our platform.</p>

        <p>
          Our customers may host applications on our platform, and these are not considered part of the platform. We may
          however choose to forward reports for these applications to the relevant customer. This includes any
          application hosted on the domains poweredbyjourney.com or onjourneyapps.com.
        </p>

        <p>We are not interested in reports of:</p>
        <ul>
          <li>
            Common non-vulnerabilities, such as those listed here:{' '}
            <a
              href="https://sites.google.com/site/bughunteruniversity/nonvuln"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://sites.google.com/site/bughunteruniversity/nonvuln
            </a>
          </li>
          <li>Issues that are not exploitable.</li>
          <li>
            Security best practice concerns. For example, issues pertaining to password policies such as password
            complexity, password reuse, etc.
          </li>
          <li>Results from automated scans.</li>
          <li>Social engineering or phishing attacks</li>
          <li>Extracting data using a compromised device or credentials.</li>
        </ul>

        <p>Please reach out to us if anything is unclear.</p>
      </>
    </SharedLegalPage>
  );
};
